'use strict';


var yaml = require('./lib/js-yaml.js');


module.exports = yaml;



//////////////////
// WEBPACK FOOTER
// ../node_modules/js-yaml/index.js
// module id = 183
// module chunks = 0